const mvalWillReset = new Set([
    "Mval96BecomesInvalid",
    "Mval96BecomesValid",
    "Mval96MustRecalculate",
]);
export const willResetMval96 = (input) => {
    if (!input)
        return false;
    const list = Array.isArray(input) ? input : [input];
    return list.some(item => mvalWillReset.has(item));
};
export const isVatClauseChanged = (input) => {
    if (!input)
        return false;
    const list = Array.isArray(input) ? input : [input];
    return list.includes("VatClauseChanged");
};
//# sourceMappingURL=mval96.js.map